import useCurrentLocationContext from '@contexts/currentLocationContext'
import { colors, fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

import { PiArrowRightBold, PiSpinnerBold } from 'react-icons/pi'
import { ButtonBase } from '@mui/material'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`

const Title = styled.h2`
  margin: 0;
  padding: ${size(1)};
`

const Message = styled.span`
  font-size: ${fontSize('xs')};
  color: lightgrey;
  text-align: center;
  max-width: 75%;
`

const LocationActionButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  background-color: ${colors.statusColors['right_now']('primary')};
  border-radius: 100px;
  margin: ${size(4)} ${size(2)};
  padding: ${size(1.5)} ${size(2.5)};
  font-weight: bold;
`

const LocationPermissionDenied = ({  }) => {
  const { retryGetPosition, isRetryingGetPosition } = useCurrentLocationContext()

  return (
    <Container>
      <Title>Please Allow Location</Title>
      <Message>
        Location permission is required to use 
        the map, grid, and nearby posts feed.
      </Message>
      <LocationActionButton onClick={retryGetPosition}>
        {isRetryingGetPosition &&
          <>
            <PiSpinnerBold
              strokeWidth={size(1)}
              size={size(2)}
              className='animation_rotation'  
            />
            &nbsp;
          </>
        }
        Retry Access
        {!isRetryingGetPosition &&
          <>&nbsp;<PiArrowRightBold /></>
        }
      </LocationActionButton>
    </Container>
  )
}

export default LocationPermissionDenied
